import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { addUser, deleteUser, getUser, getUserByEmail, updateUser } from "../../../Services/DataServices";
import GenericTable from "./GenericTable";
import { toast } from 'react-toastify';
import Loader from "../../../Components/Common/Loader";
import { useNavigate } from "react-router-dom";
import AddModal from "../../Forms/AddModal";
import EditableModal from "../../Forms/EditableModal";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { FaDownload, FaEdit, FaTrash } from "react-icons/fa";
import { companyMasterList } from "../../../../src/companyMasterList";



const UserDataCont = ({ isAddModalOpen, closeModal, setAddModalOpen, setNewUser, newUser }) => {

  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [totalItems, setTotalItems] = useState();
  const [filteredData, setFilteredData] = useState([]);

  let limit = 50;

  const fetchData = async (page = 1) => {
    setLoading(true);
    const { status, result } = await getUser(searchQuery, page, limit);
    status && setData(result.result);
    setTotalPages(result?.totalPages);
    // setTotalItems(result?.totalItems)
    setLoading(false);
  };
  const companyNames = Object.keys(companyMasterList)
  .slice(0, 1000) 
  .map((company) => ({
    companyName: company
  }));

  const DownloadCompanyNames =  Object.keys(companyMasterList)
  .map((company) => ({
    companyName: company
  }));


  const handleSearch = (event) => {
    event.preventDefault();
    
    if (!searchQuery.trim()) {
      setFilteredData(companyNames);
      return;
    }
  
    const filteredResults = companyNames.filter(company => 
      company.companyName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    setFilteredData(filteredResults);
  };
  useEffect(() => {
    if (searchQuery === "") {
      setFilteredData(companyNames); 
      setTotalItems(DownloadCompanyNames.length); 
    }
  }, [searchQuery]);


  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const response = await updateUser(selectedItem);
      setData((prevData) => {
        const updatedData = prevData.map((user) => {
          if (user._id === response.result.result._id) {
            return response.result.result;
          }
          return user;
        });
        toast.success('User edited successfully!')
        return updatedData;

      });
      closeEditModal();
    } catch (error) {
      toast.error('Error updating user!')
      console.error("Error updating user:", error);
    }
  };

  const handleDeleteData = async (event) => {
    event.preventDefault();
    try {
      const response = await deleteUser(selectedItem);
      if (response.result.response === true) {
        // fetchData(currentPage);
        toast.success('User deleted successfully!')
        closeDeleteModal();
      }
      else {
        toast.error('Error deleting user!')
      }
    } catch (error) {
      toast.error('Error deleting user!')
      console.error("Error deleting user:", error);
    }
  };

//   useEffect(() => {
//     fetchData(currentPage);
//   }, [currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSubmit = async (data) => {
    try {
      const response = await addUser(data);
      
      if (response ) {
        closeModal();
        toast.success('User Added successfully!')
      }
    } catch (err) {
      toast.error("Failed to upload file.");
    } finally {
      setLoading(false);
    //   fetchData(currentPage)
      setAddModalOpen(false);
    }
  };

  const handleDownloadCSV = () => {
    if (DownloadCompanyNames.length === 0) {
      toast.error("No data available to download.");
      return;
    }

    const csvHeader = "Company Name\n";
    const csvRows = DownloadCompanyNames.map(row => row.companyName).join("\n");
    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "company_names.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("CSV file downloaded successfully!");
  };




  const columnList = [
    {
      label: "Company Name",
      cell: (row) => row.companyName,
    },
    
  ];

  const newHandleSearch = (name) => {
    setSearchQuery(name);
    setFilteredData(companyNames.filter(company => company.companyName.toLowerCase().includes(searchQuery.toLowerCase())))
    setTotalItems(companyNames.length);
  }


  return (
    <div>
      <div style={{ display: "flex", marginBottom: "1%" }}>
      <form onSubmit={handleSearch} style={{ width: "100%", display: "flex", alignItems: "center" }}>
      <select
  defaultValue="Company" 
  style={{ marginRight: 10, padding: "8px", borderRadius: "5px", border: "1px solid gray" }}
>
  <option value="Product">Product</option>
  <option value="Company">Company</option> 
  <option value="Industry">Industry</option>
</select>


  <input
    type="text"
    placeholder={`Search by Company name`}
    value={searchQuery}
    onChange={(e) => newHandleSearch(e.target.value)}
    style={{ width: "60%", marginRight: 20, padding: "8px", borderRadius: "5px", border: "1px solid gray" }}
  />
  <h6 className="mt-2" style={{ fontSize: 20, whiteSpace: 'nowrap' }}>
                    Total: {totalItems}
                  </h6>

</form>


      <div
      onClick={handleDownloadCSV}
  type="submit"
  style={{
    display: "flex", 
    alignItems: "center", 
    gap: 8, 
    padding: 7, 
    backgroundColor: "#4b38b3", 
    color: "white", 
    borderRadius: 4,
    cursor: "pointer",
  }}
>
  <FaDownload style={{ fontSize: 16 }} />
  <span>Download</span>
</div>

    </div>

      <GenericTable
    {...{
      columnList,
      data: filteredData,
      handlePageChange,
      totalPages,
      handleEdit,
      handleDelete,
      currentPage,
      totalItems
    }}
  />
     
      
      
    </div>
  );
};

export default UserDataCont;
